import { render, staticRenderFns } from "./jcInfo.vue?vue&type=template&id=0ef7660a&scoped=true"
import script from "./jcInfo.vue?vue&type=script&lang=js"
export * from "./jcInfo.vue?vue&type=script&lang=js"
import style0 from "./jcInfo.vue?vue&type=style&index=0&id=0ef7660a&prod&lang=less&scoped=true"
import style1 from "./jcInfo.vue?vue&type=style&index=1&id=0ef7660a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7660a",
  null
  
)

export default component.exports